//選取縣市
export const SET_CITY = "SET_CITY";

export const SET_ROUTE_Info = "SET_ROUTE_Info";

export const SET_ROUTE_DIRECTION = "SET_ROUTE_DIRECTION";
//設定選取路線
export const SET_ROUTE_ESTIMATEDTIME = "SET_ROUTE_ESTIMATEDTIME";

export const SET_STOP_ESTIMATEDTIME = "SET_STOP_ESTIMATEDTIME";

export const SET_BUS_ESTIMATEDTIME = "SET_BUS_ESTIMATEDTIME ";

export const SET_BUS_REALTIME = "SET_BUS_REALTIME";

export const SET_STATION = "SET_STATION"

export const SET_STATION_POS = "SET_STATION_POS";

